<div [formGroup]="candidateForm">
	<div class="grid grid-cols-2 gap-4">
		<!-- Staff Number -->
		<div class="form-element">
			<mat-label for="form-name">Staff Number</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input
					type="text"
					formControlName="staffNumber"
					matInput
					maxlength="7"
					[readonly]="!isOnline"
					(focusout)="onFocusOut($event)"
				/>
				@if (staffNumber.errors && !staffNumber.hasError("ownStaffNumber")) {
					<mat-error>{{ sharedService.getErrorMessage(staffNumber) }}</mat-error>
				}
			</mat-form-field>
			@if (staffNumber.hasError("ownStaffNumber")) {
				<p class="mt-1 text-sm text-red">{{ sharedService.errorMessages.ownStaffNumber }}</p>
			}
		</div>

		<!-- Candidate Name -->
		<div class="form-element">
			<mat-label for="form-name">Name</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input type="text" formControlName="name" matInput [readonly]="isOnline" />
				@if (name.errors) {
					<mat-error>{{ sharedService.getErrorMessage(name) }}</mat-error>
				}
			</mat-form-field>
		</div>

		<!-- Candidate Rank -->
		<app-cbta-autocomplete
			[label]="'Rank'"
			[placeholder]="'Please Select'"
			[data]="rank.value"
			(focusOut)="saveRank($event)"
			[options]="filteredRankOptions"
			[field]="rank"
			[readonly]="false"
			[selectOnly]="true"
			[clearable]="true"
		></app-cbta-autocomplete>

		@if (isTS1) {
			<!-- Pilot Profile -->
			<app-cbta-autocomplete
				[label]="'Trainee Profile'"
				[placeholder]="'Please Select'"
				[data]="pilotProfile.value"
				(focusOut)="savePilotProfile($event)"
				[options]="sharedService.dropDownOptionsPilotProfile"
				[field]="pilotProfile"
				[selectOnly]="true"
				[clearable]="true"
			></app-cbta-autocomplete>
		}

		<!-- License Type -->
		<app-cbta-autocomplete
			[label]="'License Type'"
			[placeholder]="'Please Select'"
			[data]="licenseType.value"
			(focusOut)="saveLicenseType($event)"
			[options]="sharedService.getLicenseTypeOptions(formType)"
			[field]="licenseType"
			[readonly]="false"
			[selectOnly]="true"
			[clearable]="true"
		></app-cbta-autocomplete>

		<!-- License Expiry Date -->
		<app-cbta-datepicker
			[datePickerInput]="licenseExpiryDate"
			[inputDesign]="'formType'"
			label="License Expiry Date"
			placeHolder="DD/MM/YY"
			[defaultValue]="licenseExpiryDate.value"
			[format]="DATE_FORMAT.LICENSE_DATE_FORMAT"
			(selectedDateChange)="handleDateChange($event)"
			(onDatePickerInit)="onDatePickerInit($event)"
			[isDisabled]="licenseExpiryDate.disabled"
		></app-cbta-datepicker>

		<!-- License Number -->
		<div class="form-element">
			<mat-label for="form-name">License Number</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input type="text" formControlName="licenseNo" matInput />
				@if (licenseNo.errors) {
					<mat-error>{{ sharedService.getErrorMessage(licenseNo) }}</mat-error>
				}
			</mat-form-field>
		</div>
	</div>

	<!-- Session Configuration -->
	<div formGroupName="sessionDetails" class="px-0 py-6 lg:px-6" id="session-checkboxes">
		<p class="mb-4">Please select relevant session. Instructor can select more than <strong>ONE(1)</strong>.</p>

		<!-- 1 group -->
		@if (sessionGroups.length === 1) {
			<div
				[formGroupName]="sessionGroups[0].code"
				class="grid grid-cols-1 gap-x-16 gap-y-3 sm:grid-cols-4 lg:grid-cols-4"
			>
				@for (col of singleCols; track $index) {
					<div class="flex flex-col gap-3">
						@for (s of col; track s.code) {
							<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
						}
					</div>
				}
			</div>
		}

		<!-- 2 groups compact -->
		@if (sessionGroups.length === 3 && !twoGroupsCompact) {
			<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-4 lg:grid-cols-6">
				<div [formGroupName]="twoColsLeft!.code">
					<div class="mb-2 font-semibold">{{ twoColsLeft!.key }}</div>
					<div class="flex flex-col gap-3">
						@for (s of twoColsLeft!.items; track s.code) {
							<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
						}
					</div>
				</div>
				@for (col of twoColsRight; track $index) {
					<div [formGroupName]="sessionGroups[1].code">
						@if ($index === 0) {
							<div class="mb-2 font-semibold">{{ secondGroupTitle }}</div>
						} @else {
							<div class="mb-2">&nbsp;</div>
						}
						<div class="flex flex-col gap-3">
							@for (s of col; track s.code) {
								<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
							}
						</div>
					</div>
				}

				<div [formGroupName]="sessionGroups[2].code">
					<div class="mb-2 font-semibold">Other</div>

					<div class="flex flex-col gap-3">
						<mat-checkbox formControlName="not_required" color="primary">{{ "Not required" }}</mat-checkbox>
					</div>
				</div>
			</div>
		}

		<!-- 2 groups non-compact -->
		@if (sessionGroups.length === 4 && !twoGroupsCompact) {
			<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-4 lg:grid-cols-6">
				<div [formGroupName]="twoColsLeft!.code">
					<div class="mb-2 font-semibold">{{ twoColsLeft!.key }}</div>
					<div class="flex flex-col gap-3">
						@for (s of twoColsLeft!.items; track s.code) {
							<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
						}
					</div>
				</div>
				@for (col of twoColsRight; track $index) {
					@if (col.length > 0) {
						<div [formGroupName]="sessionGroups[1].code">
							@if ($index === 0) {
								<div class="mb-2 font-semibold">{{ secondGroupTitle }}</div>
							} @else {
								<div class="mb-2">&nbsp;</div>
							}
							<div class="flex flex-col gap-3">
								@for (s of col; track s.code) {
									<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
								}
							</div>
						</div>
					}
				}
				@for (col of lastCols; track $index) {
					<div [formGroupName]="sessionGroups[2].code">
						@if ($index === 0) {
							<div class="mb-2 font-semibold">{{ lastColTitle }}</div>
						} @else {
							<div class="mb-2">&nbsp;</div>
						}
						<div class="flex flex-col gap-3">
							@for (s of col; track s.code) {
								<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
							}
						</div>
					</div>
				}

				<div [formGroupName]="sessionGroups[3].code">
					<div class="mb-2 font-semibold">Other</div>

					<div class="flex flex-col gap-3">
						<mat-checkbox formControlName="not_required" color="primary">{{ "Not required" }}</mat-checkbox>
					</div>
				</div>
			</div>
		}

		<!-- 3+ groups -->
		@if (sessionGroups.length >= 5) {
			<div class="grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-3 lg:grid-cols-3">
				@for (g of sessionGroups; track g.code) {
					<div [formGroupName]="g.code">
						<div class="mb-2 font-semibold">{{ g.key }}</div>
						<div class="flex flex-col gap-3">
							@for (s of g.items; track s.code) {
								<mat-checkbox [formControlName]="s.code" color="primary">{{ s.description }}</mat-checkbox>
							}
						</div>
					</div>
				}
			</div>
		}

		@if (sessionGroups.length === 0) {
			<p class="italic text-gray-500">No sessions available.</p>
		}
	</div>

	<!-- Flight / Simulator Details -->
	<div class="grid grid-rows-1 gap-4">
		<div class="bg-blue-20 p-2 text-lg font-bold text-black lg:bg-violet-light lg:text-violet">
			Flight / Simulator Details
		</div>
	</div>

	<!-- add data-hide-clear flag to hide “×” visually when disabled -->
	<div
		[formGroup]="flightSimulatorDetails"
		class="grid grid-cols-2 gap-4 p-4"
		[attr.data-hide-clear]="flightSimDisabled"
	>
		<div class="form-element">
			<mat-label for="form-name">ACFT / Sim Registration</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input type="text" formControlName="aircraftSimReg" matInput />
			</mat-form-field>
		</div>

		<div class="form-element">
			<app-cbta-autocomplete
				[label]="'A/C Type'"
				[placeholder]="'Please Select'"
				[data]="acType.value"
				(focusOut)="saveACType($event)"
				[options]="sharedService.dropDownOptionsAircraftType"
				[field]="acType"
				[isDisabled]="acType.disabled"
			></app-cbta-autocomplete>
		</div>

		<div class="form-element">
			<mat-label for="form-name">Airport / Route</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input type="text" formControlName="airportRoute" matInput />
			</mat-form-field>
		</div>

		<div class="form-element">
			<app-cbta-autocomplete
				[label]="'Sector Number'"
				[placeholder]="'Please Select'"
				[data]="sectorNo.value"
				(focusOut)="saveSecNum($event)"
				[options]="sharedService.dropDownOptionsSecNum"
				[field]="sectorNo"
				[isDisabled]="sectorNo.disabled"
			></app-cbta-autocomplete>
		</div>

		<div class="form-element">
			<app-cbta-autocomplete
				[label]="'Accumulated Sectors'"
				[placeholder]="'Please Select'"
				[data]="accumulatedSectors.value"
				(focusOut)="saveAccSec($event)"
				[options]="sharedService.dropDownOptionsSecNum"
				[field]="accumulatedSectors"
				[isDisabled]="accumulatedSectors.disabled"
			></app-cbta-autocomplete>
		</div>
	</div>
</div>
